<template>
  <div style="width: 100%;height: 100%">
    <audio id="_audio_" src="../../../static/images/voice.mp3"></audio>
    <v-medium v-if="chatDataCenter.chatTerminal=='WEB'"></v-medium>
    <v-app-web v-if="chatDataCenter.chatTerminal=='H5'"></v-app-web>
  </div>

</template>

<script>
  import vMedium from "../medium/medium";
  import vAppWeb from "../appWeb/appWeb";
  import chatDataCenter from "../../jsSdk/chatDataCenter";
  import bus from '../../utils/bus';
  import common from "../../utils/common";
  export default {
    name: "web",
    components:{vMedium,vAppWeb},
    mounted:function () {
      var _this=this;
      _this.audio= document.getElementById("_audio_");
      bus.$on("enterWindow",params => {
        _this.enterInformationWindow(params.thirdId,params.curVal,params.customerChannelId)
      })
      bus.$on("audioPlay", (name) => {
        _this.audio.play();
      });
      initClickEvent = function (name) {
        chatDataCenter.clickEvent(name,_this)
      }
      openRobotLinkEvent = function (info,type) {
        // window.open($(info).attr("src"),"_blank")
      }
      window.addEventListener("click", (e) => {    
        if (e.target.tagName === "A") {
          if (e.target.href && e.target.href == "https://www.askme.com/") {
            e.preventDefault();
            const text = e.target.innerText;
            chatDataCenter.chatRoom.sendMessageByContent(text);
          }
        }
      });
    },
    computed:{
      routerQuery() {
        return this.$route.query;
      },
    },
    data() {
      return {
        audio:null,
        chatDataCenter,
      }
    },
    watch: {
      routerQuery: {
        handler(curVal, oldVal) {
          console.log(location.href)
          chatDataCenter.showChatPage=false;
          var _this = this;
          console.log('参数------',curVal)
            if (chatDataCenter.linkInfo.thirdId){
              _this.enterInformationWindow(curVal)
            }
        },
        deep: true,
        immediate:true,
      },
    },
    methods:{
      enterInformationWindow(curVal){
        const _this = this;
        if (chatDataCenter.linkInfo.thirdId&&chatDataCenter.customer&&chatDataCenter.customer.customerCode){
            chatDataCenter.customParams = {
                userId:chatDataCenter.customer.customerCode,
                userName:curVal.userName?curVal.userName:"",
                initData:(curVal.initData?curVal.initData:{}),
                otherParams:curVal
            }
            chatDataCenter._initInfo_(_this);
        }else {
            console.error("系统异常,请联系管理员:thirdId=>"+chatDataCenter.linkInfo.thirdId+";customerCode=>"+chatDataCenter.customer.customerCode)
            _this.$messageBox.Error({message:'系统异常,请联系管理员',duration:3000});
        }
      }
    }
  }
</script>

<style scoped>

</style>
